'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var stat = require('./stat.js');
var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');
var mergeOpts = require('merge-options');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mergeOpts__default = /*#__PURE__*/_interopDefaultLegacy(mergeOpts);

const mergeOptions = mergeOpts__default["default"].bind({ ignoreUndefined: true });
const defaultOptions = {};
function createFlush(context) {
  async function mfsFlush(path, options = {}) {
    options = mergeOptions(defaultOptions, options);
    const {cid} = await stat.createStat(context)(path, options);
    return cid;
  }
  return withTimeoutOption.withTimeoutOption(mfsFlush);
}

exports.createFlush = createFlush;
